"use strict";

var _interopRequireDefault = require("C:/Users/sandy/Desktop/EIOSYS/Admin/Alembic-Grow-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateRule = exports.getRules = exports.getRuleById = exports.deleteRule = exports.defaultRuleData = exports.createRule = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
const defaultRuleData = exports.defaultRuleData = {
  id: 0,
  enabled: true,
  title: '',
  message: ''
};
const getRules = params => (0, _request.default)({
  url: '/rules',
  method: 'get',
  params
});
exports.getRules = getRules;
const getRuleById = id => (0, _request.default)({
  url: `/rules/${id}`,
  method: 'get'
});
exports.getRuleById = getRuleById;
const updateRule = (id, data) => (0, _request.default)({
  url: `/rules/${id}`,
  method: 'patch',
  data
});
exports.updateRule = updateRule;
const deleteRule = id => (0, _request.default)({
  url: `/rules/${id}`,
  method: 'delete'
});
exports.deleteRule = deleteRule;
const createRule = data => (0, _request.default)({
  url: '/rules/',
  method: 'post',
  data
});
exports.createRule = createRule;